


















































































































import { Component, Watch, Vue, Prop } from 'vue-property-decorator'

@Component
export default class OrderListHeader extends Vue {
  private isActive: boolean = false
  @Prop() private isCloseToggle!: boolean
  private showAllInner () {
    this.isActive = !this.isActive
    this.$emit('show-all-inner', this.isActive)
  }
  @Watch('isCloseToggle')
  private closeToggle (value: boolean) {
    this.isActive = !value
  }
  /* ソート */
  private sortList (val: string) {
    this.$emit('sort-order-list', val)
  }
}
